import { getTenantInfoByKey } from "../../../helpers/helpers"

export default function getIdFromScanResult(QRScanResult) {
    try {
        switch (getTenantInfoByKey('qr_employee_type')) {
            case 'ar-DNI':
                if (QRScanResult.split('@').length < 7) {
                    return undefined
                }
                if (QRScanResult.split('@').length > 9) {
                    return {
                        name: QRScanResult.split('@')[5],
                        lastName: QRScanResult.split('@')[4],
                        documentNumber: QRScanResult.split('@')[1].trim(),
                    }
                }
                return {
                    name: QRScanResult.split('@')[2],
                    lastName: QRScanResult.split('@')[1],
                    documentNumber: QRScanResult.split('@')[4],
                }
            case 'exactian-credential':
                return JSON.parse(QRScanResult)[getTenantInfoByKey('credential_emp_id_label')]
            default:
                return undefined
        }
    } catch (e) {
        console.log(e)
        return undefined
    }
};
